import React, { Component } from 'react';
import {ApiBaseUrl} from '../../constants';
import { AuthContext } from "./../../context/auth";
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { trackPromise } from 'react-promise-tracker';
import { withSnackbar } from 'react-simple-snackbar';

class EditProfile extends Component{
    static contextType = AuthContext;
    state = {
        firstname : '',
        lastname : '',
        email : '',
        phone : '',
        image : '',
        imageBase64: '',
        src: null,
        crop: {
            unit: '%',
            width: 50,
            aspect: 1 / 1,
        },
        hideCrop: true
    }

    imageChangeHandler = (event) =>{
        const imageFiles = event.target.files;
        const imageFile = imageFiles[0];

        if (!imageFile) {
            this.props.openSnackbar('Please select image.')
            this.setState({
                imageBase64: ''
            });
            return false;
        }

        if (!imageFile.name.match(/\.(jpg|jpeg|png|gif)$/)) {
            this.props.openSnackbar('Please select valid image.')
            this.setState({
                imageBase64: ''
            });
            return false;
        }

        this.setState({
            hideCrop: false
        })
        if (event.target.files && event.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener('load', () =>
                this.setState({ src: reader.result })
            );
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    onImageLoaded = image => {
        this.imageRef = image;
    };

    onCropComplete = crop => {
        this.makeClientCrop(crop);
    };

    onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({ crop });
    };

    async makeClientCrop(crop) {
        if (this.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                crop,
                'newFile.jpeg'
            );
            this.setState({ croppedImageUrl });
        }
    }

    getCroppedImg(image, crop, fileName) {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        const base64Image = canvas.toDataURL('image/jpeg');
        this.setState({
            imageBase64: btoa(base64Image)
        });

        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (!blob) {
                    return;
                }
                blob.name = fileName;
                window.URL.revokeObjectURL(this.fileUrl);
                this.fileUrl = window.URL.createObjectURL(blob);
                resolve(this.fileUrl);
            }, 'image/jpeg');
        });
    }

    handleNameChange = (event) => {
        const {name,value} = event.target;
        this.setState({
            [name] : value
        })
    }

    handleFormSubmit = (event) => {
        event.preventDefault();

        let formBody = "firstname="+ encodeURIComponent(this.state.firstname)+'&lastname='+encodeURIComponent(this.state.lastname);
        if(this.state.imageBase64)
            formBody+='&image='+encodeURIComponent(this.state.imageBase64);
        fetch(ApiBaseUrl + "/consumer/update_consumer",
            {
                method: 'PUT',
                body: formBody,
                headers:
                    {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(result.success){
                        localStorage.setItem('silverbackToken', result.data.token);
                        this.context.token=result.data.token;
                        this.setState({
                            image: result.data.image
                        });
                    }
                    this.props.openSnackbar(result.message)
                    if(result.success)
                        this.props.history.push(process.env.PUBLIC_URL+'/profile')
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        trackPromise(
        fetch(ApiBaseUrl + "/consumer/profile",
            {
                method: 'GET',
                headers:
                    {
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(!result.success)
                        this.props.openSnackbar(result.message)
                    else
                        this.setState({
                            firstname : result.data.firstname,
                            lastname : result.data.lastname,
                            email : result.data.email,
                            phone : result.data.phone,
                            image : result.data.image
                        });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    hideCrop = () => {
        this.setState({
            hideCrop: true
        })
    }

    render(){
        const { crop, croppedImageUrl, src } = this.state;

        return(
            <div className="choose-deals-outer p-l-0 p-r-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-7 col-lg-5 mx-auto px-0 px--xs-0">
                        <div className="loginform-box">
                            <h6 className="socaillogin-headingtext">Edit your account details to proceed</h6>
                            <form autoComplete="off" onSubmit={this.handleFormSubmit}>
                                <div className="text-md-center">
                                    <div className="sociallogin-uploadouter">
                                        <div className="sociallogin-profilepic">
                                            {croppedImageUrl ?
                                            <img alt="Crop" src={croppedImageUrl} />:<img src={this.state.image} alt="sociallogin-profilepic"/>}
                                        </div>
                                        <input onChange={this.imageChangeHandler} type="file" accept="image/*" id="upload__img"/>
                                            <label htmlFor="upload__img" className="pluscircle--btn"><img src={`${process.env.PUBLIC_URL}/image/plus.png`} alt="uplaod-icon"/>
                                            </label>
                                    </div>
                                    {src && this.state.hideCrop!==true && (
                                        <React.Fragment>
                                            <div className="row bg-grey p-3 mb-3 text-center">
                                                <div className="col-md-12">
                                            <ReactCrop
                                                src={src}
                                                crop={crop}
                                                ruleOfThirds
                                                onImageLoaded={this.onImageLoaded}
                                                onComplete={this.onCropComplete}
                                                onChange={this.onCropChange}
                                            />
                                                    <div className="col-md-12">
                                            <button className="entry-btn cancel-btn grad-on w-xs-100" type="button" onClick={this.hideCrop}>Done</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )}
                                </div>
                                <div className="mob-flex">
                                    <div className="changepswd-rows mob50">
                                        <label className="green-color">First Name</label>
                                    <div className="eye">
                                        <input type="text" className="form-control" name="firstname" onChange={this.handleNameChange} value={this.state.firstname}/>
                                    </div>
                                </div>
                                    <div className="changepswd-rows mob50">
                                        <label className="green-color">Last Name</label>
                                    <div className="eye">
                                        <input type="text" className="form-control" name="lastname" onChange={this.handleNameChange} value={this.state.lastname}/>
                                    </div>
                                </div>
                                </div>
                                    <div className="changepswd-rows mt-md-4">
                                        <label className="green-color">Email Address</label>
                                    <div className="eye">
                                        <input type="email" className="form-control forgotpswd__input w-100" name="e-name" value={this.state.email} readOnly/>
                                    </div>
                                </div>
                                    <div className="changepswd-rows adjust-xs">
                                        <label className="green-color">Phone Number</label>
                                    <input type="tel" id="phoneedit" className="form-control forgotpswd__input w-100" placeholder="" value={this.state.phone} readOnly/>
                                </div>

                                <div className="btn-rowstack text-center">
                                    <button className="entry-btn cancel-btn w-xs-100" type="submit">Save</button>
                                </div>
                            </form>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withSnackbar(EditProfile,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});